'use client';

import React from 'react';
import { IScheduleDemoFormValues } from '@framework/ui/Organisms/ScheduleDemo/ScheduleDemoForm/interfaces';
import BookDemoButtonComponent from '../../BookDemoButton';
import { Tenant } from '@framework/tenant/vo/types/Tenant';
import useScheduleDemoModal from '../useScheduleDemoModal';
import { ButtonVariantType } from '@dealroadshow/uikit-button';
import { ILogoProps } from '@dealroadshow/uikit-logo/types';

export interface IProps {
  tenant: Tenant,
  logoComponent?: React.ComponentType<ILogoProps>,
  buttonComponent?: React.ElementType,
  title?: string,
  className?: string,
  variantType?: keyof typeof ButtonVariantType,
  defaultPhoneCountry?: string,
  getInitialFormValues?: () => IScheduleDemoFormValues | null,
  openModalWithUrl?: () => void,
  dataTest?: string,
}

const BookDemoButton = ({
  tenant,
  logoComponent,
  buttonComponent,
  title,
  className,
  variantType,
  defaultPhoneCountry,
  getInitialFormValues,
  openModalWithUrl,
  dataTest,
}: IProps) => {
  const {
    isScheduleDemoModalVisible,
    toggleScheduleDemoModal,
    ScheduleDemoModal,
  } = useScheduleDemoModal();

  return (
    <BookDemoButtonComponent
      isScheduleDemoModalVisible={ isScheduleDemoModalVisible }
      toggleScheduleDemoModal={ toggleScheduleDemoModal }
      scheduleDemoModal={ ScheduleDemoModal }
      tenant={ tenant }
      // @ts-ignore
      logoComponent={ logoComponent }
      buttonComponent={ buttonComponent }
      title={ title }
      className={ className }
      variantType={ variantType as keyof typeof ButtonVariantType }
      defaultPhoneCountry={ defaultPhoneCountry }
      getInitialFormValues={ getInitialFormValues }
      openModalWithUrl={ openModalWithUrl }
      dataTest={ dataTest }
    />
  );
};

export default BookDemoButton;
